import { render, staticRenderFns } from "./UserTop.vue?vue&type=template&id=4ecd5ae7"
import script from "./UserTop.vue?vue&type=script&lang=js"
export * from "./UserTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports